import ko from "knockout";
import template from "./index.html";

ko.components.register('client-avatar', {
	viewModel: function(params) {
		const client = ko.utils.unwrapObservable(params.client);

		this.avatarUrl = null;
		this.hasAvatar = false;
		this.text = '';

		if (!client) {
			this.hasAvatar = true;
			this.avatarUrl = '/player/images/avatar.svg';

			return;
		}

		if (client.avatar() && client.avatar() !== '/player/images/avatar.svg') {
			this.hasAvatar = true;
			this.avatarUrl = client.avatar();

			return;
		}

		this.text = client.nickname().substr(0, 1);
		if (!this.text) {
			this.text = (
				(client.info().name || '').substr(0, 1) + (client.info().surname || '').substr(0, 1)
			).trim();
		}
	},
	template
});
